'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');

var RadioIcon = React.createClass({
  propTypes: {
    isSelected: React.PropTypes.oneOfType([React.PropTypes.bool,React.PropTypes.string]),
    size: React.PropTypes.number,
    color: React.PropTypes.string,
    left: React.PropTypes.number,
    top: React.PropTypes.number,
    enabled:React.PropTypes.oneOfType([React.PropTypes.bool,React.PropTypes.string])
  },

  defaultSize: 16,

  render: function () {
    var enabled = true;
    if(this.props.enabled !== undefined){
      enabled = this.props.enabled === true || this.props.enabled === 'true';
    }
    var style = {
      width: this.props.size || this.defaultSize,
      height: this.props.size || this.defaultSize,
      left: this.props.left || 0,
      top: this.props.top || 0,
      position: this.props.position || 'absolute',
      cursor: 'pointer',
      pointerEvents : enabled?'auto':'none'
    };
    return (<canvas style={style} width={style.width} height={style.width} onClick={this.props.onClick}/>);
  },

  componentDidMount: function () {
    this.repaint();
  },

  componentDidUpdate: function () {
    this.repaint();
  },

  componentWillUnmount : function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  repaint: function () {
    var canvas = ReactDOM.findDOMNode(this);
    var graphics = canvas.getContext('2d');
    var self = this;
    var size = this.props.size || this.defaultSize;
    var centerX = size / 2;
    var centerY = size / 2;
    var radius;
    var strokeColor = styleHelper.getBorderColor(this.props) || '#000';
    this.requestID = window.requestAnimationFrame(function () {
      graphics.clearRect(0, 0, size, size);
      graphics.fillStyle = '#fff';
      graphics.strokeStyle = strokeColor;

      graphics.lineWidth = 1;
      graphics.beginPath();
      radius = size / 2 - 0.5;
      graphics.arc(centerX, centerY, radius, 0, 360);
      graphics.closePath();
      graphics.fill();
      graphics.stroke();
      if (self.props.isSelected) {
        graphics.beginPath();
        radius = size / 4;
        graphics.arc(centerX, centerY, radius, 0, 360);
        graphics.fillStyle = strokeColor;
        graphics.closePath();
        graphics.fill();
      }

    });
  }
});

module.exports = RadioIcon;


// WEBPACK FOOTER //
// ./src/views/common/RadioIcon.jsx